// Adaptation of https://codepen.io/tutsplus/pen/RRVRro

export const CLASS_NAME = 'o-LazyYoutube'

export default function replaceAsyncYoutube(
  content: string,
  title: string
): string {
  return content.replace(
    /\[youtube:([\w-]+)\]/gi,
    `<div class="${CLASS_NAME}" data-embed="$1"><button type="button" class="${CLASS_NAME}__playButton" title="${title}"></button><img src="https://img.youtube.com/vi/$1/sddefault.jpg" class="${CLASS_NAME}__previewImage" /></div>`
  )
}
